import Image from "next/legacy/image";
import { Section, SectionProps } from "@/components/layout/Section";
import { Button, ButtonProps } from "@/components/UI/buttons/Button";
import { ReactNode } from "react";

export type SectionCTAProps = Omit<SectionProps, "icon"> & {
  img?: 1 | 2;
  className?: string;
  button: ButtonProps;
  last?: boolean;
  note?: ReactNode;
};

export const SectionCTA = ({
  heading,
  subheading,
  img = 1,
  className,
  button,
  last,
  note,
  gradient = "cta",
}: SectionCTAProps) => (
  <Section
    icon="/img/icons/sections/icon-bulb.svg"
    heading={heading}
    subheading={subheading}
    gradient={gradient}
    className={className}
    direction="horizontal"
    buttons={<Button {...button} />}
    note={note}
    last={last}
  >
    <div className="mdMin">
      <Image src={`/img/cta/cta-${img}.svg`} alt="Illustration" width={530} height={img === 1 ? 445 : 455} />
    </div>
  </Section>
);
